import React, { useMemo, useState } from "react";

const YEARS = [1948, 1949, 1950, 1951, 1952, 1953, 1954, 1955, 1956, 1957, 1958, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 1969, 1970, 1971, 1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979, 1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026];
const PROD = [101.2, 103.2, 111.0, 113.0, 115.5, 120.1, 123.2, 130.8, 132.8, 136.2, 138.2, 144.2, 146.2, 151.1, 156.9, 162.9, 168.2, 174.0, 178.9, 181.4, 187.4, 189.6, 192.8, 201.7, 209.6, 212.9, 207.0, 212.6, 217.8, 219.9, 222.2, 219.5, 214.0, 217.5, 215.3, 222.1, 227.3, 231.1, 236.5, 235.4, 238.6, 240.2, 241.1, 242.8, 252.0, 253.2, 255.2, 255.4, 258.8, 262.7, 268.1, 274.1, 277.4, 282.0, 291.4, 301.3, 310.4, 316.4, 318.5, 322.2, 319.3, 332.3, 342.1, 339.2, 340.4, 344.4, 346.9, 353.5, 355.6, 359.9, 364.8, 370.6, 385.5, 395.4, 390.0, 396.0, 404.8, 412.4, 419.1];
const PAY = [101.2, 107.8, 112.0, 112.1, 115.8, 121.2, 125.3, 130.4, 134.8, 137.6, 138.6, 142.8, 145.6, 148.4, 152.1, 155.8, 159.3, 163.0, 165.4, 168.3, 171.7, 175.9, 177.7, 182.9, 192.0, 191.8, 187.5, 187.0, 189.1, 192.5, 195.0, 192.8, 188.0, 186.9, 187.4, 188.8, 187.7, 187.3, 188.9, 186.9, 186.4, 186.6, 185.5, 185.7, 187.2, 187.8, 188.3, 187.5, 187.8, 189.9, 194.5, 197.4, 198.3, 202.5, 207.3, 210.0, 209.8, 209.7, 210.6, 212.9, 213.3, 222.3, 224.7, 222.1, 220.2, 223.0, 224.1, 228.5, 231.4, 232.4, 234.8, 238.9, 247.8, 247.4, 242.7, 245.4, 249.7, 253.4, 253.8];

const DECADES = [
  { key: "1948-1959", from: 1948, to: 1959 }, { key: "1960-1969", from: 1960, to: 1969 }, { key: "1970-1979", from: 1970, to: 1979 },
  { key: "1980-1989", from: 1980, to: 1989 }, { key: "1990-1999", from: 1990, to: 1999 }, { key: "2000-2009", from: 2000, to: 2009 },
  { key: "2010-2019", from: 2010, to: 2019 }, { key: "2020-2026", from: 2020, to: 2026 },
];

const PHASES = [
  { label: { it: "Gran Bretagna 1780-1840", en: "Great Britain 1780-1840" }, prod: 46, pay: 12 },
  { label: { it: "Gran Bretagna 1840-1900", en: "Great Britain 1840-1900" }, prod: 90, pay: 123 },
  { label: { it: "Stati Uniti 1948-1979", en: "United States 1948-1979" }, prod: 112.5, pay: 90.2 },
  { label: { it: "Stati Uniti 1979-2019", en: "United States 1979-2019" }, prod: 59.7, pay: 15.8 },
];

const T = {
  it: {
    title: "Salari e produttività negli Stati Uniti: insieme fino al 1979, poi la forbice",
    sub: "Indice 1948 = 100. Produttività netta dell'intera economia e retribuzione oraria reale (salari + benefit) dei lavoratori non dirigenti. Trascina il cursore o passa sul grafico.",
    prod: "Produttività", pay: "Retribuzioni reali", gap: "Divario", year: "Anno", ratio: "rapporto",
    since48: "dal 1948", decadeTitle: "Confronto per decennio", decadeSub: "Crescita cumulata nel decennio, in percentuale. Tocca un decennio per evidenziarlo sul grafico.",
    phasesTitle: "Le quattro fasi dell'articolo", ratioExpl: "Rapporto = crescita delle retribuzioni divisa per la crescita della produttività.",
    source: "Fonte: Economic Policy Institute, Productivity-Pay Tracker (aggiornato settembre 2026), medie annue dei dati trimestrali; Gran Bretagna: R. C. Allen, «Engels' pause» (2009). Le percentuali USA nel testo si riferiscono alla versione 2021 della stessa serie.",
    pts: "punti indice",
  },
  en: {
    title: "US wages and productivity: together until 1979, then the scissors open",
    sub: "Index 1948 = 100. Net productivity of the total economy and real hourly compensation (wages + benefits) of production and non-supervisory workers. Drag the slider or hover the chart.",
    prod: "Productivity", pay: "Real pay", gap: "Gap", year: "Year", ratio: "ratio",
    since48: "since 1948", decadeTitle: "Decade by decade", decadeSub: "Cumulative growth within the decade, in percent. Tap a decade to highlight it on the chart.",
    phasesTitle: "The four phases in the article", ratioExpl: "Ratio = pay growth divided by productivity growth.",
    source: "Source: Economic Policy Institute, Productivity-Pay Tracker (updated September 2026), annual averages of quarterly data; Great Britain: R. C. Allen, 'Engels' pause' (2009). US percentages in the text refer to the 2021 vintage of the same series.",
    pts: "index points",
  },
};

const W = 760, H = 320, PAD = { l: 44, r: 16, t: 16, b: 28 };
const Y0 = 90, Y1 = 440;
const xOf = y => PAD.l + ((y - 1948) / (2026 - 1948)) * (W - PAD.l - PAD.r);
const yOf = v => PAD.t + (1 - (v - Y0) / (Y1 - Y0)) * (H - PAD.t - PAD.b);
const line = arr => arr.map((v, i) => `${i ? "L" : "M"}${xOf(YEARS[i]).toFixed(1)},${yOf(v).toFixed(1)}`).join(" ");
const fmt = (v, lang, d = 1) => { const s = Number(v).toFixed(d); return lang === "it" ? s.replace(".", ",") : s; };
const sign = (v, lang, d = 1) => (v > 0 ? "+" : "") + fmt(v, lang, d);
const growth = (arr, a, b) => ((arr[YEARS.indexOf(b)] / arr[YEARS.indexOf(a)]) - 1) * 100;

export const WageProductivityChart = ({ lang = "it" }) => {
  const ui = T[lang] ? lang : "en";
  const t = T[ui];
  const [year, setYear] = useState(1979);
  const [hoverYear, setHoverYear] = useState(null);
  const [decade, setDecade] = useState(null);
  const cur = hoverYear ?? year;
  const i = YEARS.indexOf(cur);
  const dec = DECADES.find(d => d.key === decade);

  const paths = useMemo(() => ({
    prod: line(PROD), pay: line(PAY),
    area: `${line(PROD)} ${[...PAY].map((v, k) => `L${xOf(YEARS[PAY.length - 1 - k]).toFixed(1)},${yOf(PAY[PAY.length - 1 - k]).toFixed(1)}`).join(" ")} Z`,
  }), []);

  const onMove = e => {
    const svg = e.currentTarget; const r = svg.getBoundingClientRect();
    const px = ((e.clientX - r.left) / r.width) * W;
    const y = Math.round(1948 + ((px - PAD.l) / (W - PAD.l - PAD.r)) * (2026 - 1948));
    setHoverYear(Math.min(2026, Math.max(1948, y)));
  };

  const decadeRows = DECADES.map(d => {
    const p = growth(PROD, d.from, d.to), w = growth(PAY, d.from, d.to);
    return { ...d, p, w, ratio: p > 0 ? w / p : NaN };
  });
  const maxG = Math.max(...decadeRows.map(r => Math.max(r.p, Math.abs(r.w))), 10);

  return (
    <section className="wpc" data-testid="wage-productivity-chart" dir="ltr">
      <h3 className="wpc-title">{t.title}</h3>
      <p className="wpc-sub">{t.sub}</p>
      <div className="wpc-legend">
        <span><i className="wpc-swatch prod" /> {t.prod}</span>
        <span><i className="wpc-swatch pay" /> {t.pay}</span>
        <span><i className="wpc-swatch gap" /> {t.gap}</span>
      </div>
      <svg viewBox={`0 0 ${W} ${H}`} className="wpc-svg" onMouseMove={onMove} onMouseLeave={() => setHoverYear(null)}
        onTouchMove={e => { const tch = e.touches[0]; onMove({ currentTarget: e.currentTarget, clientX: tch.clientX }); }} data-testid="wpc-svg" role="img" aria-label={t.title}>
        {dec && <rect x={xOf(dec.from)} y={PAD.t} width={xOf(dec.to) - xOf(dec.from)} height={H - PAD.t - PAD.b} className="wpc-decade-band" />}
        {[100, 150, 200, 250, 300, 350, 400].map(v => (
          <g key={v}><line x1={PAD.l} x2={W - PAD.r} y1={yOf(v)} y2={yOf(v)} className="wpc-grid" /><text x={PAD.l - 6} y={yOf(v) + 4} textAnchor="end" className="wpc-tick">{v}</text></g>
        ))}
        {[1950, 1960, 1970, 1980, 1990, 2000, 2010, 2020].map(y => <text key={y} x={xOf(y)} y={H - 8} textAnchor="middle" className="wpc-tick">{y}</text>)}
        <path d={paths.area} className="wpc-area" />
        <path d={paths.prod} className="wpc-line prod" />
        <path d={paths.pay} className="wpc-line pay" />
        <line x1={xOf(1979)} x2={xOf(1979)} y1={PAD.t} y2={H - PAD.b} className="wpc-1979" />
        <text x={xOf(1979) + 4} y={PAD.t + 10} className="wpc-tick">1979</text>
        <g className="wpc-cursor" data-testid="wpc-cursor">
          <line x1={xOf(cur)} x2={xOf(cur)} y1={PAD.t} y2={H - PAD.b} />
          <circle cx={xOf(cur)} cy={yOf(PROD[i])} r="5" className="prod" />
          <circle cx={xOf(cur)} cy={yOf(PAY[i])} r="5" className="pay" />
        </g>
      </svg>
      <div className="wpc-controls">
        <input type="range" min="1948" max="2026" step="1" value={year} onChange={e => { setYear(+e.target.value); setDecade(null); }}
          className="wpc-slider" aria-label={t.year} data-testid="wpc-slider" />
        <div className="wpc-readout" data-testid="wpc-readout">
          <div className="wpc-readout-year" data-testid="wpc-readout-year">{cur}</div>
          <div><span className="wpc-k prod">{t.prod}</span> <b>{fmt(PROD[i], ui)}</b> <small>{sign(PROD[i] - 100, ui)}% {t.since48}</small></div>
          <div><span className="wpc-k pay">{t.pay}</span> <b>{fmt(PAY[i], ui)}</b> <small>{sign(PAY[i] - 100, ui)}% {t.since48}</small></div>
          <div><span className="wpc-k gap">{t.gap}</span> <b>{fmt(PROD[i] - PAY[i], ui)}</b> <small>{t.pts} · {t.ratio} {fmt(PROD[i] > 100 ? (PAY[i] - 100) / (PROD[i] - 100) : 1, ui, 2)}</small></div>
        </div>
      </div>

      <h4 className="wpc-h4">{t.decadeTitle}</h4>
      <p className="wpc-sub">{t.decadeSub}</p>
      <div className="wpc-decades" data-testid="wpc-decades">
      <div className="wpc-phase wpc-head" aria-hidden="true"><span /><span className="wpc-decade-label">{t.prod}</span><span className="wpc-decade-label">{t.pay}</span><span className="wpc-ratio">{t.ratio}</span></div>
        {decadeRows.map(r => (
          <button key={r.key} type="button" className={`wpc-decade ${decade === r.key ? "active" : ""}`}
            onClick={() => { const on = decade !== r.key; setDecade(on ? r.key : null); if (on) setYear(r.to); }} data-testid={`wpc-decade-${r.from}`} aria-pressed={decade === r.key}>
            <span className="wpc-decade-label">{r.key}</span>
            <span className="wpc-bar prod" style={{ width: `${(Math.max(r.p, 0) / maxG) * 72}%` }}><em>{sign(r.p, ui, 0)}%</em></span>
            <span className="wpc-bar pay" style={{ width: `${(Math.max(r.w, 0) / maxG) * 72}%` }}><em>{sign(r.w, ui, 0)}%</em></span>
            <span className="wpc-ratio">{Number.isFinite(r.ratio) ? fmt(r.ratio, ui, 2) : "–"}</span>
          </button>
        ))}
      </div>

      <h4 className="wpc-h4">{t.phasesTitle}</h4>
      <div className="wpc-phases" data-testid="wpc-phases">
      <div className="wpc-phase wpc-head" aria-hidden="true"><span /><span className="wpc-decade-label">{t.prod}</span><span className="wpc-decade-label">{t.pay}</span><span className="wpc-ratio">{t.ratio}</span></div>
        {PHASES.map(ph => (
          <div key={ph.label.en} className="wpc-phase">
            <span className="wpc-decade-label">{ph.label[ui]}</span>
            <span className="wpc-bar prod" style={{ width: `${(ph.prod / 130) * 72}%` }}><em>{sign(ph.prod, ui, ph.prod % 1 ? 1 : 0)}%</em></span>
            <span className="wpc-bar pay" style={{ width: `${(ph.pay / 130) * 72}%` }}><em>{sign(ph.pay, ui, ph.pay % 1 ? 1 : 0)}%</em></span>
            <span className="wpc-ratio">{fmt(ph.pay / ph.prod, ui, 2)}</span>
          </div>
        ))}
      </div>
      <p className="wpc-note">{t.ratioExpl}</p>
      <p className="wpc-note">{t.source}</p>
    </section>
  );
};

export default WageProductivityChart;
